import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ExamineFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return i(d, n(a, {
    icon: o
  }), null);
};
r.displayName = "ExamineFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
